<template>
  <div class="content">
    <div class="form_page_wrapper">
      <div class="logo-div">
        <router-link :to="'/'"
          ><img src="../../../assets/images/logo.png" alt="homepage"
        /></router-link>
      </div>
      <div v-if="initError">
        <h1 class="text-danger border-0">{{ initError.message }}</h1>
      </div>
      <div v-else>
        <form class="content-form">
          <h1 v-if="res && res.passwordExist" class="form_header">
            Generate Password
          </h1>
          <h1 v-else class="form_header">Create Password</h1>
          <div class="form-group">
            <label class="control-label" htmlFor="password">Password </label>
            <span class="text-danger">*</span>
            <input
              type="password"
              class="form-control"
              v-model="data.password"
              @blur="$v.data.password.$touch()"
            />
            <p
              class="alert alert-danger"
              v-if="!$v.data.password.required && $v.data.password.$error"
            >
              This field is required
            </p>
            <p
              class="alert alert-danger"
              v-if="!$v.data.password.minLength && $v.data.password.$error"
            >
              Password must have atleast 8 characters.
            </p>
            <p
              class="alert alert-danger"
              v-if="
                $v.data.password.required &&
                !$v.data.password.passwordValidator &&
                $v.data.password.$error
              "
            >
              Invalid Password. The password requires an uppercase, lowercase,
              number and special character.
            </p>
          </div>
          <div class="form-group">
            <label class="control-label" htmlFor="confirmPassword"
              >Confirm Password
            </label>
            <span class="text-danger">*</span>
            <input
              type="password"
              class="form-control"
              v-model="data.confirmPassword"
              @blur="$v.data.confirmPassword.$touch()"
            />
            <p
              class="alert alert-danger"
              v-if="
                !$v.data.confirmPassword.required &&
                $v.data.confirmPassword.$error
              "
            >
              This field is required
            </p>
            <p
              class="alert alert-danger"
              v-if="
                data.confirmPassword && !$v.data.confirmPassword.sameAsPassword
              "
            >
              Password and Confirm Password should match
            </p>
          </div>

          <vue-recaptcha
            ref="recaptcha"
            :sitekey="sitekey"
            @verify="onVerify"
            @expired="onExpired"
          >
          </vue-recaptcha>

          <div class="form-footer text-right">
            <button
              type="button"
              class="btn btn-cp"
              style="margin-right: 10px"
              @click="submit()"
              :disabled="this.isDisabled"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../_api/index";
import VueRecaptcha from "vue-recaptcha";

import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      resetPasswordId: this.$route.params.resetPasswordId,
      data: {
        password: "",
        confirmPassword: "",
      },
      sitekey: "6Lc1jlkUAAAAAFR2xokl-fUNU9lgg3BV__2T2IbN",
      isCaptchaVerified: false,
      linkExpired: true,
      email: "",
      setPassword: false,
      initError: null,
      res: null,
    };
  },
  methods: {
    async submit() {
      const data = {
        accountPassword: this.data.password,
        resetPasswordId: this.resetPasswordId,
      };
      api
        .resetPassword(data)
        .then(() => {
          this.$store.dispatch(
            "openSnackbar",
            { type: "success", message: "Password updated successfully!" },
            { root: true }
          );
          this.$router.push("/login?as=recruiter");
        })
        .catch((err) => {
          this.$store.dispatch(
            "openSnackbar",
            {
              type: "danger",
              message: err.response.message
                ? err.response.message
                : "Something went wrong!",
            },
            { root: true }
          );
        });
    },

    onVerify() {
      this.isCaptchaVerified = true;
    },
    onExpired() {
      this.isCaptchaVerified = false;
    },
    passwordValidator(value) {
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]+$/.test(
        value
      );
    },
    entityNameValidator(value) {
      return /^[^-\s][a-zA-Z. ]*$/.test(value);
    },
  },
  components: {
    VueRecaptcha,
  },
  validations() {
    const data = {
      password: {
        required,
        minLength: minLength(8),
        passwordValidator: this.passwordValidator,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs("password"),
      },
    };
    return { data };
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
  },
  beforeMount() {
    this.initError = null;
    api
      .checkExpiry(this.$route.params.resetPasswordId)
      .then((data) => {
        this.res = data.data;
        this.linkExpired = data.data.isExpired;
        this.email = data.data.email;
      })
      .catch((err) => {
        this.initError = err.response.data;
      });
  },
};
</script>

<style scoped>
.logo-div {
  padding-top: 10px;
  display: flex;
  justify-content: space-around;
}

.form_page_wrapper {
  width: 800px;
  padding-bottom: 20px;
  margin: 100px auto auto auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
}

.form_page_wrapper .form-footer {
  border: 0px;
}

.updateOptions {
  padding-left: 40px;
}

@media screen and (max-width: 1366px) {
  .form_page_wrapper {
    width: 80%;
  }
}

@media screen and (max-width: 760px) {
  .form_page_wrapper {
    width: 70%;
  }
}

.form_page_wrapper .form_header {
  font-size: 26px;
  text-align: center;
  font-weight: 500;
  padding-top: 10px;
  border: 0px;
  margin-bottom: 10px;
}

.form_page_wrapper label {
  font-weight: 600;
  font-size: 14px;
}

.form_page_wrapper input:focus {
  box-shadow: none;
}

.form_page_wrapper select:focus {
  box-shadow: none;
}

.m-10 {
  margin: 5px 10px;
}
</style>
